import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MygalleriesRoutingModule } from './mygalleries-routing.module';
import { MygalleriesComponent } from './mygalleries.component';
import { HeaderGalleriesComponent } from '../../components/header-galleries/header-galleries.component';
import { GalleriesComponent } from '../../components/galleries/galleries.component';
import { HeaderComponent } from '../../components/header/header.component';


@NgModule({
  declarations: [
    MygalleriesComponent,
  //  NewgalleriesComponent,
    
  ],
  imports: [
    CommonModule,
    MygalleriesRoutingModule,
    HeaderGalleriesComponent,
    GalleriesComponent,HeaderComponent
  ]
})
export class MygalleriesModule { }
